import { DoorOpen, FileText, Key, Settings, Trash2, Upload, UserPlus, UserX } from 'lucide-react'
import type { ActivityType } from './types'

export const ACTIVITY_ICONS: Record<ActivityType, { icon: typeof DoorOpen; color: string }> = {
  login: { icon: DoorOpen, color: 'text-blue-400' },
  invite_sent: { icon: UserPlus, color: 'text-emerald-400' },
  invite_accepted: { icon: UserPlus, color: 'text-emerald-400' },
  member_removed: { icon: UserX, color: 'text-amber-400' },
  settings_changed: { icon: Settings, color: 'text-muted-foreground' },
  data_exported: { icon: Upload, color: 'text-blue-400' },
  pitch_submitted: { icon: FileText, color: 'text-[#f97316]' },
  api_key_created: { icon: Key, color: 'text-amber-400' },
  account_deleted: { icon: Trash2, color: 'text-red-400' },
}

export const ACTIVITY_LABELS: Record<ActivityType, string> = {
  login: 'Sign in',
  invite_sent: 'Invite',
  invite_accepted: 'Joined',
  member_removed: 'Removed',
  settings_changed: 'Settings',
  data_exported: 'Export',
  pitch_submitted: 'Pitch',
  api_key_created: 'API Key',
  account_deleted: 'Deleted',
}
